import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/figma")({
  component: () => (
    <Breadcrumb label="Figma" to="/figma">
      <Outlet />
    </Breadcrumb>
  ),
});
